import request from '@/utils/request'

const url = '/auth-service'

export function feedback(id, predicate = 'DELIVERY_CONTENT_AUDIT') {
  return request({
    url: `${url}/stat_logs/page`,
    method: 'post',
    params: {
      fromChannel: 'LOG_PAGE',
      functionModel: 'AUDIT_MODEL',
      objectId: id,
      // predicate: predicate // 内容审核-DELIVERY_CONTENT_AUDIT 签约信息审核-DELIVERY_SIGN_INFO_AUDIT
    }
  })
}
